import * as React from 'react';
import styled from 'styled-components';

interface IArrow {
  className: string;
}

export const ArrowIcon: React.FC<IArrow> = ({ className }) => {
  return (
    <StyledArrow className={className}>
      <svg
        width="43"
        height="26"
        viewBox="0 0 43 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.05347 1.53195L21.476 22.7344L41.0059 1.6309"
          stroke="black"
          strokeWidth="2"
        />
      </svg>
    </StyledArrow>
  );
};

const StyledArrow = styled.div``;

interface ICloseIcon {
  className: string;
  onClick?: () => void;
}

export const CloseIcon: React.FC<ICloseIcon> = ({ className, onClick }) => {
  return (
    <StyledIcon className={className} onClick={onClick}>
      <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7 0.3C13.3 -0.1 12.7 -0.1 12.3 0.3L7 5.6L1.7 0.3C1.3 -0.1 0.7 -0.1 0.3 0.3C-0.1 0.7 -0.1 1.3 0.3 1.7L5.6 7L0.3 12.3C-0.1 12.7 -0.1 13.3 0.3 13.7C0.5 13.9 0.7 14 1 14C1.3 14 1.5 13.9 1.7 13.7L7 8.4L12.3 13.7C12.5 13.9 12.8 14 13 14C13.2 14 13.5 13.9 13.7 13.7C14.1 13.3 14.1 12.7 13.7 12.3L8.4 7L13.7 1.7C14.1 1.3 14.1 0.7 13.7 0.3Z"
          fill="#FFFFFF"
        />
      </svg>
    </StyledIcon>
  );
};

const StyledIcon = styled.div`
  width: 24px;
  height: 24px;
`;
